
const videoCategory = {
    path: '/videoMange/videoCategory',
    component: resolve => require(['@/views/videoMange/videoCategory'], resolve),
    name: 'videoCategory',
    meta: {
        title: '视频类别',
    }
};

const videoUserCategory = {
    path: '/videoMange/videoUserCategory',
    component: resolve => require(['@/views/videoMange/videoUserCategory'], resolve),
    name: 'videoUserCategory',
    meta: {
        title: '用户视频类别',
    }
};

const videoTitle = {
    path: '/videoMange/videoTitle',
    component: resolve => require(['@/views/videoMange/videoTitle'], resolve),
    name: 'videoTitle',
    meta: {
        title: '视频栏目',
    }
};

const video = {
    path: '/videoMange/Video',
    component: resolve => require(['@/views/videoMange/Video'], resolve),
    name: 'video',
    meta: {
        title: '视频管理'
    }
};

const videoComment = {
    path: '/videoMange/videoComment',
    component: resolve => require(['@/views/videoMange/videoComment'], resolve),
    name: 'videoComment',
    meta: {
        title: '视频评论'
    }
};

const addVideo = {
    path: '/videoMange/addVideo',
    component: resolve => require(['@/views/videoMange/addVideo'], resolve),
    name: 'addVideo',
    meta: {
        title: '视频'
    }
};
export default [videoCategory, videoUserCategory, videoTitle, video, videoComment,addVideo]


// WEBPACK FOOTER //
// ./src/router/modules/videoMange.js